export const VALIDATION_MESSAGES = {
  STRICT_LOGIC_NO_CONDITIONS: "At least one condition is required.",
  STRICT_LOGIC_INCOMPLETE_CONDITION:
    "Every condition must have a parent metric, operator, and threshold.",
  AGGREGATE_NO_PARENTS: "At least one parent metric is required.",
  AGGREGATE_COUNT_WHERE_NO_TARGET:
    "count_where_target is required for COUNT_WHERE aggregation.",
} as const
